import { FormFieldsBoxMui as FormFieldsBox } from '@spotify/confidence-core-react';
import { MetricsV1MetricRatioMetricSpec as RatioSpec } from '@spotify/confidence-graphql';

import { MetricFilters } from '../MetricFilters';
import { AggregatedMeasurement } from './AggregatedMeasurement';

type RatioFormProps = {
  value: RatioSpec;
  entity?: string;
  factTable: string;
  onChange: (newRatioSpec: RatioSpec) => void;
};

export const RatioForm = ({
  value,
  entity = '',
  factTable,
  onChange,
}: RatioFormProps) => (
  <FormFieldsBox>
    <AggregatedMeasurement.Root
      measurement={value.numerator}
      aggregation={value.numeratorAggregation}
      entity={entity}
      factTable={factTable}
      onChange={(measurement, aggregation) => {
        onChange({
          ...value,
          numerator: measurement ? { name: measurement.name } : undefined,
          numeratorAggregation: {
            ...value.numeratorAggregation,
            ...aggregation,
          },
        });
      }}
     data-track-source-anchor="4f3e65f71e;ratio-form-root">
      <AggregatedMeasurement.Select
        label="Numerator"
        helperText="The value to divide."
        disabledOptions={
          value.denominator?.name ? [value.denominator.name] : undefined
        }
       data-track-source-anchor="bfcc694295"/>
      <AggregatedMeasurement.Type
        label="Numerator method"
        data-testid="numerator-method-select"
      />
      <AggregatedMeasurement.Cap
        idPrefix="ratio-numerator"
        valueLabel="numerator values"
        short
      />
    </AggregatedMeasurement.Root>

    <MetricFilters
      label="Numerator filter"
      factTable={factTable}
      filter={value.numeratorFilter}
      onChange={newFilter => {
        onChange({ ...value, numeratorFilter: newFilter });
      }}
     data-track-source-anchor="2b82bced2d"/>

    <AggregatedMeasurement.Root
      measurement={value.denominator}
      aggregation={value.denominatorAggregation}
      entity={entity}
      factTable={factTable}
      onChange={(measurement, aggregation) => {
        onChange({
          ...value,
          denominator: measurement ? { name: measurement.name } : undefined,
          denominatorAggregation: {
            ...value.denominatorAggregation,
            ...aggregation,
          },
        });
      }}
     data-track-source-anchor="0dc2c53d20;ratio-form-root-2">
      <AggregatedMeasurement.Select
        label="Denominator"
        helperText="The value to divide by."
        disabledOptions={
          value.numerator?.name ? [value.numerator.name] : undefined
        }
       data-track-source-anchor="03f7036ee2"/>
      <AggregatedMeasurement.Type
        label="Denominator method"
        data-testid="denominator-method-select"
      />
      <AggregatedMeasurement.Cap
        idPrefix="ratio-denominator"
        valueLabel="denominator values"
        short
      />
    </AggregatedMeasurement.Root>

    <MetricFilters
      label="Denominator filter"
      factTable={factTable}
      filter={value.denominatorFilter}
      onChange={newFilter => {
        onChange({ ...value, denominatorFilter: newFilter });
      }}
     data-track-source-anchor="edc95cac84"/>
  </FormFieldsBox>
);
